import React, { useState } from "react";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { isEmpty } from "ramda";

import { PageLoader, Pagination, Table } from "clearsense-ui/components";
import NoData from "components/Common/NoData";
import { useAirbyteState } from "contexts/airbyte";
import useInterval from "hooks/useInterval";

import { columns } from "./data";

import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from "../constants";

dayjs.extend(relativeTime);

const DBTable = ({
  setSelectedRows,
  connections,
  createConnection,
  editConnection,
  pollConnections,
  isLoading,
  debouncedSearchString,
}) => {
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);

  const { workspaceId } = useAirbyteState();

  useInterval(() => {
    if (workspaceId) pollConnections(workspaceId);
  }, 10000);

  if (isLoading) {
    return <PageLoader />;
  } else if (!connections?.length && isEmpty(debouncedSearchString)) {
    return (
      <NoData
        entity="connections"
        actionLabel="Create Connection"
        onAction={createConnection}
      />
    );
  }

  return (
    <div className="cs-ui-table-background rounded-sm">
      <Table
        isLoading={isLoading}
        columnData={columns}
        rowData={connections}
        onRow={conn => ({ onClick: () => editConnection(conn) })}
        rowSelection={{ columnWidth: 65, fixed: true }}
        rowKey={record => record.key}
        onRowSelect={selectedRowKeys => setSelectedRows(selectedRowKeys)}
        totalCount={connections.length}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        paginationProps={{ pageSize }}
        currentPageNumber={pageNumber}
        handlePageChange={page => setPageNumber(page)}
      />
      <Pagination
        showResultsPerPage
        totalRecordsCount={connections.length}
        currentPage={pageNumber}
        setCurrentPage={setPageNumber}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageSizeOptionsList={Array.from(
          { length: 5 },
          (_, index) => DEFAULT_PAGE_SIZE + index * 5
        )}
        className="px-6 py-2 m-0"
      />
    </div>
  );
};

export default DBTable;
